export const AboutCvv = {
  en_us: '3 or 4 digits, usually on the back of the card (up front on AMEX cards)',
  pt_br: '3 ou 4 dígitos, geralmente no verso do cartão (na frente em cartões AMEX)'
}

export const Addresses = {
  en_us: 'Addresses',
  pt_br: 'Endereços'
}

export const AtSight = {
  en_us: 'At sight',
  pt_br: 'À vista'
}

export const BackToCart = {
  en_us: 'Back to cart',
  pt_br: 'Voltar ao carrinho'
}

export const Bag = {
  en_us: 'Bag',
  pt_br: 'Sacola'
}

export const Birthdate = {
  en_us: 'Birthdate',
  pt_br: 'Data de nascimento'
}

export const Borough = {
  en_us: 'Borough',
  pt_br: 'Bairro'
}

export const Buyer = {
  en_us: 'Buyer',
  pt_br: 'Comprador'
}

export const CardNumber = {
  en_us: 'Card number',
  pt_br: 'Número do cartão'
}

export const Cellphone = {
  en_us: 'Cellphone',
  pt_br: 'Celular'
}

export const ChangePaymentMethod = {
  en_us: 'Change payment method',
  pt_br: 'Alterar forma de pagamento'
}

export const ChangeShippingMethod = {
  en_us: 'Change shipping method',
  pt_br: 'Alterar forma de envio'
}

export const Checkout = {
  en_us: 'Checkout',
  pt_br: 'Finalizar compra'
}

export const City = {
  en_us: 'City',
  pt_br: 'Cidade'
}

export const CodeCopied = {
  en_us: 'Code copied',
  pt_br: 'Código copiado'
}

export const CompanyRegistration = {
  en_us: 'Company registration',
  pt_br: 'Pessoa jurídica'
}

export const Complement = {
  en_us: 'Complement',
  pt_br: 'Complemento'
}

export const ConfirmPurchase = {
  en_us: 'Confirm purchase',
  pt_br: 'Confirmar compra'
}

export const ContactPhone = {
  en_us: 'Contact phone',
  pt_br: 'Telefone de contato'
}

export const Continue = {
  en_us: 'Continue',
  pt_br: 'Continuar'
}

export const CopyCode = {
  en_us: 'Copy code',
  pt_br: 'Copiar código'
}

export const CopyErrorMsg = {
  en_us: 'Error copying to clipboard, please copy manually',
  pt_br: 'Erro ao copiar para a área de transferência, por favor copie manualmente'
}

export const Days = {
  en_us: 'Days',
  pt_br: 'Dias'
}

export const Delivery = {
  en_us: 'Delivery',
  pt_br: 'Entrega'
}

export const Discount = {
  en_us: 'Discount',
  pt_br: 'Desconto'
}

export const DocNumber = {
  en_us: 'Document number',
  pt_br: 'Número do documento'
}

export const CorporateName = {
  en_us: 'Corporate Name',
  pt_br: 'Razão Social'
}

export const DoPaymentMsg = {
  en_us: 'Please finalize the payment to confirm your purchase',
  pt_br: 'Por favor finalize o pagamento para confirmar sua compra'
}

export const Edit = {
  en_us: 'Edit',
  pt_br: 'Editar'
}

export const EmailAddress = {
  en_us: 'Email address',
  pt_br: 'Endereço de e-mail'
}

export const EnterYourDocNumber = {
  en_us: 'Enter your document number to confirm',
  pt_br: 'Confirme o login com seu documento'
}

export const EnterYourEmail = {
  en_us: 'Enter your email to proceed',
  pt_br: 'Informe seu email para prosseguir'
}

export const Female = {
  en_us: 'Female',
  pt_br: 'Feminino'
}

export const Freight = {
  en_us: 'Freight',
  pt_br: 'Frete'
}

export const FullName = {
  en_us: 'Full name',
  pt_br: 'Nome completo'
}

export const GenderX = {
  en_us: 'Other',
  pt_br: 'Outro'
}

export const GenerateBillet = {
  en_us: 'Generate billet',
  pt_br: 'Gerar boleto'
}

export const Hello = {
  en_us: 'Hello',
  pt_br: 'Olá'
}

export const HelloAgain = {
  en_us: 'Hello again',
  pt_br: 'Olá novamente'
}

export const HolderName = {
  en_us: 'Holder name',
  pt_br: 'Nome do titular'
}

export const Identification = {
  en_us: 'Identification',
  pt_br: 'Identificação'
}

export const IdentifyAccount = {
  en_us: 'Identify your account',
  pt_br: 'Identificar ou criar sua conta'
}

export const InterestFree = {
  en_us: 'Interest-free',
  pt_br: 'Sem juros'
}

export const InvalidCard = {
  en_us: 'Invalid card info',
  pt_br: 'Cartão inválido'
}

export const InvalidCardMsg = {
  en_us: 'Unable to validate this card, please check the data or try again later',
  pt_br: 'Não foi possível validar este cartão, por favor verifique os dados ou tente novamente mais tarde'
}

export const InvalidLoginInfo = {
  en_us: 'Invalid login info, please verify',
  pt_br: 'Login inválido, por favor verifique os dados informados'
}

export const IsNotYou = {
  en_us: 'Is not you',
  pt_br: 'Não é você'
}

export const Logout = {
  en_us: 'Logout',
  pt_br: 'Sair'
}

export const LoginError = {
  en_us: 'Login error',
  pt_br: 'Erro no login'
}

export const Male = {
  en_us: 'Male',
  pt_br: 'Masculino'
}

export const ManageYourHistory = {
  en_us: 'Manage your purchase history',
  pt_br: 'Gerenciar seu histórico de compras'
}

export const MyAccount = {
  en_us: 'My account',
  pt_br: 'Minha conta'
}

export const MyOrders = {
  en_us: 'My orders',
  pt_br: 'Meus pedidos'
}

export const Name = {
  en_us: 'Name',
  pt_br: 'Nome'
}

export const NameOnCard = {
  en_us: 'Name on card',
  pt_br: 'Nome impresso no cartão'
}

export const Nickname = {
  en_us: 'Nickname',
  pt_br: 'Apelido'
}

export const NewAddress = {
  en_us: 'New address',
  pt_br: 'Novo endereço'
}

export const NotifyAboutOrders = {
  en_us: 'Notify about progress of the order',
  pt_br: 'Notificar sobre o andamento do pedido'
}

export const NoNumber = {
  en_us: 'No number',
  pt_br: 'S/N'
}

export const Number = {
  en_us: 'Number',
  pt_br: 'Número'
}

export const OauthOnPopup = {
  en_us: 'Continue login on popup',
  pt_br: 'Continue o login no pop-up'
}

export const Of = {
  en_us: 'Of',
  pt_br: 'De'
}

export const OfDiscount = {
  en_us: 'Of discount',
  pt_br: 'De desconto'
}

export const OnFreight = {
  en_us: 'On freight',
  pt_br: 'No frete'
}

export const Orders = {
  en_us: 'Orders',
  pt_br: 'Pedidos'
}

export const OrderCreated = {
  en_us: 'Order created',
  pt_br: 'Recebemos seu pedido'
}

export const OrderConfirmationMsg = {
  en_us: 'Your order has been confirmed, thanks for your preference',
  pt_br: 'Seu pedido foi confirmado, obrigado pela preferência'
}

export const OrderNumber = {
  en_us: 'Order number',
  pt_br: 'Número do pedido'
}

export const OrProceedWith = {
  en_us: 'Or proceed with',
  pt_br: 'Ou prossiga com'
}

export const ParcelIn = {
  en_us: 'Parcel in',
  pt_br: 'Parcelar em'
}

export const Payment = {
  en_us: 'Payment',
  pt_br: 'Pagamento'
}

export const ProceedToPayment = {
  en_us: 'Proceed to payment',
  pt_br: 'Prosseguir para pagamento'
}

export const PaymentConfirmed = {
  en_us: 'Payment',
  pt_br: 'Pagamento confirmado'
}

export const PaymentRealized = {
  en_us: 'Payment realized',
  pt_br: 'Pagamento realizado'
}

export const PaymentError = {
  en_us: 'Payment error',
  pt_br: 'Erro no pagamento'
}

export const PaymentErrorMsg = {
  en_us: 'Unable to approve purchase, please verify details or try another payment method',
  pt_br: 'Não foi possível aprovar a compra, por favor verifique os dados ou tente com outra forma de pagamento'
}

export const PersonalRegistration = {
  en_us: 'Personal registration',
  pt_br: 'Pessoa física'
}

export const PrintBillet = {
  en_us: 'Print billet',
  pt_br: 'Imprimir boleto'
}

export const ProfileNotFound = {
  en_us: 'No profile found with email address',
  pt_br: 'Nenhum perfil encontrado com o endereço de e-mail'
}

export const ProvinceCode = {
  en_us: 'Province code',
  pt_br: 'UF'
}

export const Recipient = {
  en_us: 'Recipient',
  pt_br: 'Destinatário'
}

export const RedirectToPayment = {
  en_us: 'Redirect to payment',
  pt_br: 'Efetuar pagamento'
}

export const Reference = {
  en_us: 'Reference',
  pt_br: 'Referência'
}

export const RegisterToBuy = {
  en_us: 'Complete your registration to proceed with the purchase',
  pt_br: 'Complete seu cadastro para prosseguir com a compra'
}

export const Remove = {
  en_us: 'Remove',
  pt_br: 'Remover'
}

export const Registration = {
  en_us: 'Registration',
  pt_br: 'Cadastro'
}

export const Save = {
  en_us: 'Save',
  pt_br: 'Salvar'
}

export const SecurityCode = {
  en_us: 'Security code',
  pt_br: 'Código de segurança'
}

export const SignInWith = {
  en_us: 'Sign in with',
  pt_br: 'Entrar com'
}

export const ShippingMethod = {
  en_us: 'Shipping options',
  pt_br: 'Forma de envio'
}

export const Street = {
  en_us: 'Street',
  pt_br: 'Rua'
}

export const Summary = {
  en_us: 'Summary',
  pt_br: 'Resumo'
}

export const Total = {
  en_us: 'Total'
}

export const TicketCode = {
  en_us: 'Ticket code',
  pt_br: 'Código de barras do boleto'
}

export const UpTo = {
  en_us: 'Up to',
  pt_br: 'Até'
}

export const ValidThru = {
  en_us: 'Valid thru',
  pt_br: 'Validade'
}

export const WasAnErrorOnLogin = {
  en_us: 'There was an error trying to login, please try again or select another option',
  pt_br: 'Houve um erro ao tentar o login, por favor tente novamente ou selecione outra opção'
}

export const WeUseYourDataTo = {
  en_us: 'We will use your data safely and responsibly to',
  pt_br: 'Usaremos seus dados com segurança e responsabilidade para'
}

export const WillReceiveMsg = {
  en_us: 'You\'ll receive the products in up to',
  pt_br: 'Você receberá os produtos em até'
}

export const WorkingDays = {
  en_us: 'Working days',
  pt_br: 'Dias úteis'
}

export const ZipCode = {
  en_us: 'Zip code',
  pt_br: 'CEP'
}

export const _FinancialStatus = {
  pending: {
    en_us: 'Pending payment',
    pt_br: 'Pagamento pendente'
  },
  under_analysis: {
    en_us: 'Payment under analysis',
    pt_br: 'Pagamento em análise'
  },
  authorized: {
    en_us: 'Authorized payment',
    pt_br: 'Pagamento autorizado'
  },
  unauthorized: {
    en_us: 'Unauthorized payment',
    pt_br: 'Pagamento não autorizado'
  },
  partially_paid: {
    en_us: 'Partially paid',
    pt_br: 'Parcialmente pago'
  },
  paid: {
    en_us: 'Paid',
    pt_br: 'Pago'
  },
  in_dispute: {
    en_us: 'Payment in dispute',
    pt_br: 'Pagamento em disputa'
  },
  partially_refunded: {
    en_us: 'Payment partially refunded',
    pt_br: 'Pagamento parcialmente devolvido'
  },
  refunded: {
    en_us: 'Payment refunded',
    pt_br: 'Pagamento devolvido'
  },
  voided: {
    en_us: 'Payment voided',
    pt_br: 'Pagamento cancelado'
  },
  unknown: {
    en_us: 'Unknown payment status',
    pt_br: 'Situação do pagamento desconhecida'
  }
}

export const _OrderStatus = {
  open: {
    en_us: 'Open order',
    pt_br: 'Pedido em aberto'
  },
  closed: {
    en_us: 'Finalized order',
    pt_br: 'Pedido finalizado'
  },
  cancelled: {
    en_us: 'Cancelled',
    pt_br: 'Cancelado'
  }
}

export const _FulfillmentStatus = {
  ready_for_shipping: {
    en_us: 'Ready for shipping',
    pt_br: 'Preparado para envio'
  },
  shipped: {
    en_us: 'Shipped',
    pt_br: 'Produtos enviados'
  },
  delivered: {
    en_us: 'Delivered',
    pt_br: 'Entregue'
  }
}
